import React from 'react';
//import Link from './Link';
import moment from 'moment';

//import { FormattedMessage } from 'react-intl';

const intlStatus = {
    new: 'Новая',
    agreement: 'Согласование',
    agreed: 'Назначенная',
    visited: 'Состоявшаяся',
    late: 'Просроченная',
    declined: 'Отменена',
    waiting: 'Лист ожидания',
    old: 'Старая',
    personally: 'На связи лично'
}

//компонент деталей встречи персоны
const VisitDetals = ({visit}) => {
    return (
        <div className='VisitDetals'>
           <h1 className='VisitDetals-title'>Подробности встречи</h1>
           <div className='VisitDetals-items'>
                {visit.user && 
                    <div className='VisitDetals-item __fullSize'>
                        <div className='VisitDetals-item-tile'>Меценат:</div>
                        <div className='VisitDetals-item-content'>{`${visit.user.surname} ${visit.user.name}`}</div>
                    </div>
                }
                {visit.status &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Статус:</div>
                        <div className='VisitDetals-item-content'>{intlStatus[visit.status]}</div>
                    </div>
                }
                {visit.date &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Дата/время встречи:</div>
                        <div className='VisitDetals-item-content'>{moment(visit.date).add(3, 'hours').utc().format('DD.MM.YYYY, HH:mm')}</div>
                    </div>
                }
                {(visit.visitDates && visit.visitDates.person && visit.visitDates.person.length > 0) &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Выбранные вами даты встречи:</div>
                        <div className='VisitDetals-item-content'>
                            {visit.visitDates.person.map((date, i) => 
                                <span key={i} className='visit-time'>{moment(date).add(3, 'hours').utc().format('DD.MM.YYYY, HH:mm')}</span>
                            )}
                        </div>
                    </div>
                }
                {(visit.visitDates && visit.visitDates.user && visit.visitDates.user.length > 0) &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Выбранная дата встречи меценатом:</div>
                        <div className='VisitDetals-item-content'>
                            {visit.visitDates.user.map((date, i) => 
                                <span key={i} className='visit-time'>{moment(date).add(3, 'hours').utc().format('DD.MM.YYYY, HH:mm')}</span>
                            )}
                        </div>
                    </div>
                }
                {visit.placeName &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Место встречи:</div>
                        <div className='VisitDetals-item-content'>{visit.placeName}</div>
                    </div>
                }
                {visit.place &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Адрес:</div>
                        <div className='VisitDetals-item-content'>{visit.place}</div>
                    </div>
                }
                {visit.description &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Подробности встречи:</div>
                        <div className='VisitDetals-item-content'>{visit.description}</div>
                    </div>
                }
                {visit.comment &&
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Комментарий ко встрече:</div>
                        <div className='VisitDetals-item-content'>{visit.comment}</div>
                    </div>
                }
                {visit.result && 
                    <div className='VisitDetals-item'>
                        <div className='VisitDetals-item-tile'>Результат встречи:</div>
                        <div className='VisitDetals-item-content'>{visit.result}</div>
                    </div>
                }
           </div>
        </div> 
    )
}

export default VisitDetals;


// WEBPACK FOOTER //
// ./src/components/VisitDetals.jsx